export const IGNORED_SENTRY_ERRORS: (string | RegExp)[] = [
  // The error occurred component will in many cases be logging a duplicate
  // of an error we already logged. We don't want to double-report these to Sentry,
  // so should ignore the ones coming from the error occurred component.
  /ErrorOccurredComponent errorReason/,
  '[LaunchDarkly] Error on stream connection: {"isTrusted":true}',
  '[LaunchDarkly] The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied.',
  'LogRocket: insertRule/deleteRule rate limit exceeded',
  'Failed to match page route in useGetCurrentPage. Current pathname is: /ce-internal/flags',
  // Amplitude Replay logger warns a *lot* about stuff we don't care about:
  /Amplitude Logger \[Warn\]:/,
];
